import Vue from "vue";
import Router from "vue-router";
import api from "./util/backend";
import store from "./store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./views/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "dashboard",
          component: () => import("./views/pages/Dashboard.vue")
        },
        {
          path: "/curriculumtype",
          name: "curriculumtype",
          component: () => import("./views/pages/CurriculumType.vue")
        },
        {
          path: "/curriculum",
          name: "curriculum",
          component: () => import("./views/pages/Curriculum.vue")
        },
        {
          path: "/organization",
          name: "organization",
          component: () => import("./views/pages/Organization.vue")
        },
        {
          path: "/banner",
          name: "banner",
          component: () => import("./views/pages/Banner.vue")
        },

        {
          path: "/lecturer",
          name: "lecturer",
          component: () => import("./views/pages/Lecturer.vue")
        },
        {
          path: "/addcourse/:id",
          name: "addcurriculum",
          component: () => import("./views/pages/Addpages/Addtemplate.vue"),
          props: {
            default: true,
            type: "course"
          }
        },
        {
          path: "/addcurriculumType",
          name: "addcurriculumType",
          component: () => import("./views/pages/Addpages/Addtemplate.vue"),
          props: {
            default: true,
            type: "curriculumType"
          }
        },
        {
          path: "/addcurriculum",
          name: "addcurriculum",
          component: () => import("./views/pages/Addpages/Addtemplate.vue"),
          props: {
            default: true,
            type: "curriculum"
          }
        },
        {
          path: "/addadministrator",
          name: "addadministrator",
          component: () => import("./views/pages/Addpages/Addtemplate.vue"),
          props: {
            default: true,
            type: "administrator"
          }
        },
        {
          path: "/addvideo/:id",
          name: "addvideo",
          component: () => import("./views/pages/Addpages/Addtemplate.vue"),
          props: {
            default: true,
            type: "video"
          }
        },
        {
          path: "/addorganization",
          name: "addorganization",
          component: () => import("./views/pages/Addpages/Addtemplate.vue"),
          props: {
            default: true,
            type: "organization"
          }
        },
        {
          path: "/addlecturer",
          name: "addlecturer",
          component: () => import("./views/pages/Addpages/Addtemplate.vue"),
          props: {
            default: true,
            type: "lecturer"
          }
        },
        {
          path: "/addbanner",
          name: "addbanner",
          component: () => import("./views/pages/Addpages/Addtemplate.vue"),
          props: {
            default: true,
            type: "banner"
          }
        },
        {
          path: "/curriculum/:id",
          name: "curriculumdetail",
          component: () =>
            import("./views/pages/Detailpage/CurriculumDetail.vue"),
          props: true
        },
        {
          path: "/course/:id",
          name: "coursedetail",
          component: () => import("./views/pages/Detailpage/CourseDetail.vue"),
          props: true
        },
        {
          path: "/lecturer/:id",
          name: "lecturerdatail",
          component: () =>
            import("./views/pages/Detailpage/LecturerDetail.vue"),
          props: true
        },
        {
          path: "/course/edit/:id",
          name: "editcourse",
          component: () => import("./views/pages/Editpages/Edittemplete.vue"),
          props: {
            default: true,
            type: "course"
          }
        },
        {
          path: "/curriculum/edit/:id",
          name: "editcurriculum",
          component: () => import("./views/pages/Editpages/Edittemplete.vue"),
          props: {
            default: true,
            type: "curriculum"
          }
        },
        {
          path: "/curriculumType/edit/:id",
          name: "editcurriculumtype",
          component: () => import("./views/pages/Editpages/Edittemplete.vue"),
          props: {
            default: true,
            type: "curriculumType"
          }
        },
        {
          path: "/organization/edit/:id",
          name: "editorganization",
          component: () => import("./views/pages/Editpages/Edittemplete.vue"),
          props: {
            default: true,
            type: "organization"
          }
        },
        {
          path: "/video/edit/:id",
          name: "editvideo",
          component: () => import("./views/pages/Editpages/Edittemplete.vue"),
          props: {
            default: true,
            type: "video"
          }
        },
        {
          path: "/lecturer/edit/:id",
          name: "editlecturer",
          component: () => import("./views/pages/Editpages/Edittemplete.vue"),
          props: {
            default: true,
            type: "lecturer"
          }
        },
        {
          path: "/banner/edit/:id",
          name: "editbanner",
          component: () => import("./views/pages/Editpages/Edittemplete.vue"),
          props: {
            default: true,
            type: "banner"
          }
        },
        {
          path: "/administrator/edit/:id",
          name: "editadministrator",
          component: () => import("./views/pages/Editpages/Edittemplete.vue"),
          props: {
            default: true,
            type: "administrator"
          }
        },
        {
          path: "/payment",
          name: "payment",
          component: () => import("./views/pages/Payment.vue")
        },
        {
          path: "/user",
          name: "user",
          component: () => import("./views/pages/User.vue")
        },
        {
          path: "/user/:id",
          name: "userdatail",
          component: () => import("./views/pages/Detailpage/UserDetail.vue"),
          props: true
        },
        {
          path: "/administrator",
          name: "administrator",
          component: () => import("./views/pages/Administrator.vue"),
          meta: {
            requireAuth: true
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/views/pages/Login_FAstation.vue")
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue")
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  //alert("token",store.getters['general/token'])
  let token = localStorage.getItem("token");
  console.log("check token", store.getters["general/token"].token);
  if (to.meta.requireAuth && token) {
    // await api.tokenlogin().then( async (res)=>{
    //   localStorage.setItem('token', res.data.data.access_token)
    //   localStorage.setItem('refresh_token', res.data.data.refresh_token)
    //   await store.dispatch("general/get_userInfo",{
    //     token: res.data.data.access_token,
    //     RefreshToken: res.data.data.refresh_token,
    //     data: res.data.data
    //   })
    //   next();
    // })
    // .catch((err)=>{
    //   console.log(err);
    //   next({path:'/pages/login'})
    // })
    next();
  } else if (to.meta.requireAuth && !token) {
    next({ path: "/pages/login" });
  } else {
    next();
  }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
